<template>
  <div>
    <h6>{{ this.$t('lang.search.empty_search_error') }}</h6>
    <img
      class="align-middle"
      src="../../assets/img/illustrations/alert-person.svg"
      width="90%"
      style="max-height: 300px"
    >
    <p>{{ this.$t('lang.search.we_will_work') }}</p>
  </div>
</template>

<script>
export default {
  name: 'EmptyResultsMessage',
};
</script>

<style scoped>

</style>
